import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Camera, ShoppingBag } from "lucide-react";
import { api } from "../../lib/api";
import { media } from "../../lib/community";
import { money } from "../../lib/social";
import { PostCard, Composer } from "../community/CommunityKit";

const empty = (Icon, text, id) => <div className="py-16 text-center text-[var(--muted)]" data-testid={id}><Icon className="w-8 h-8 mx-auto text-[#C9A25A] mb-3" /><p className="font-serif text-2xl text-[var(--ink)]">{text}</p></div>;

export function PostsTab({ v, user }) {
  const [posts, setPosts] = useState(null);
  const [me, setMe] = useState(null);
  const handle = v.owner?.handle;
  useEffect(() => { if (handle) api.get(`/community/profiles/${handle}/posts`).then((r) => setPosts(r.data)).catch(() => setPosts([])); else setPosts([]); }, [handle]);
  useEffect(() => { if (v.relationship?.is_owner && user) api.get("/community/me").then((r) => setMe(r.data)).catch(() => {}); }, [v.relationship?.is_owner, user]);
  return (
    <div className="max-w-2xl space-y-4" data-testid="vendor-posts-tab">
      {me && v.owner?.user_id === user?.user_id && <div data-testid="vendor-owner-composer"><Composer me={me} placeholder="Share a recent wedding, a reel or a special offer…" onPosted={(p) => setPosts((x) => [p, ...(x || [])])} /></div>}
      {posts?.map((p) => <PostCard key={p.post_id} post={p} user={user} onDeleted={(id) => setPosts((x) => x.filter((y) => y.post_id !== id))} />)}
      {posts && !posts.length && empty(Camera, v.type === "unclaimed" ? "Posts appear once the business claims this page" : "No posts yet", "vendor-posts-empty")}
    </div>
  );
}

export function PortfolioTab({ v }) {
  const [big, setBig] = useState(null);
  if (!v.photos?.length) return empty(Camera, "No portfolio photos yet", "vendor-portfolio-empty");
  return (
    <>
      <div className="columns-2 md:columns-3 gap-3 [column-fill:_balance]" data-testid="vendor-portfolio-grid">
        {v.photos.map((p, i) => (
          <button key={p.url + i} onClick={() => setBig(p.url)} className="mb-3 block w-full overflow-hidden rounded-2xl bg-[#F3EEE5] group" data-testid={`vendor-portfolio-item-${i}`}>
            <img src={media(p.url)} alt="" loading="lazy" onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }} className="w-full h-auto group-hover:scale-[1.03] transition-transform duration-500" />
          </button>
        ))}
      </div>
      {big && <button onClick={() => setBig(null)} className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4" data-testid="vendor-portfolio-lightbox"><img src={media(big)} alt="" className="max-w-full max-h-full rounded-xl" /></button>}
    </>
  );
}

export function ShopTab({ v }) {
  if (!v.shop?.length) return empty(ShoppingBag, "Nothing in the shop yet", "vendor-shop-empty");
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="vendor-shop-grid">
      {v.shop.map((l) => (
        <Link key={l.listing_id} to={`/market/item/${l.listing_id}`} className="group rounded-2xl overflow-hidden bg-white border border-[var(--line)] hover:border-[#C9A25A] transition-colors" data-testid={`vendor-shop-item-${l.listing_id}`}>
          <div className="aspect-square bg-[#F3EEE5] overflow-hidden">{l.photos?.[0] && <img src={media(`/api/files/${l.photos[0]}`)} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}</div>
          <div className="p-3"><p className="text-sm font-medium truncate">{l.title}</p><p className="text-sm text-[#A38243] font-semibold">{l.kind === "free" ? "Free" : money(l.price)}</p></div>
        </Link>
      ))}
    </div>
  );
}
